import React from "react";
import { Document, Page, View, Text, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: "Helvetica",
    color: "#000000",
    backgroundColor: "#ffffff",
  },
  headerContainer: {
    alignItems: "center",
    marginBottom: 15,
    lineHeight: 1.3,
  },
  topTitle: {
    fontSize: 12,
    fontWeight: "bold",
    textDecoration: "underline",
    marginBottom: 2,
  },
  companyName: {
    fontSize: 16,
    fontWeight: "bold",
  },
  companyAddress: {
    fontSize: 9,
    textAlign: "center",
    maxWidth: 500,
  },
  boldText: {
    fontWeight: "bold",
  },
  metaRowContainer: {
    flexDirection: "row",
    borderWidth: 1,
    borderColor: "#000000",
    marginBottom: 15,
  },
  metaHalfCell: {
    width: "50%",
    padding: 6,
    flexDirection: "row",
  },
  metaHalfCellRight: {
    width: "50%",
    padding: 6,
    flexDirection: "row",
    borderLeftWidth: 1,
    borderLeftColor: "#000000",
  },
  receivedBox: {
    borderWidth: 1,
    borderColor: "#000000",
    padding: 15,
    marginBottom: 15,
  },
  receivedLine: {
    marginBottom: 8,
    fontSize: 11,
  },
  amountBox: {
    borderWidth: 1,
    borderColor: "#000000",
    padding: 12,
    marginBottom: 20,
    backgroundColor: "#f7f7f7",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  amountLabel: {
    fontSize: 12,
    fontWeight: "bold",
  },
  amountValue: {
    fontSize: 16,
    fontWeight: "bold",
  },
  balanceRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderTopWidth: 1,
    borderTopColor: "#000000",
    paddingTop: 8,
    marginTop: 8,
  },
  signBlock: {
    marginTop: 40,
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  signBox: {
    width: 180,
    textAlign: "center",
    borderTopWidth: 1,
    borderTopColor: "#000000",
    paddingTop: 5,
  },
  disclaimer: {
    fontSize: 7,
    color: "#555555",
    marginTop: 30,
    textAlign: "center",
  }
});

// props: { payment, customer: { name, phone, address }, balanceAfter }
export default function ReceiptPDF({ payment = {}, customer = {}, balanceAfter = 0 }) {
  const receiptNo = "RCPT-" + (payment.id || Date.now().toString().slice(-8));
  const dateStr = payment.payment_date
    ? new Date(payment.payment_date).toLocaleDateString("en-IN")
    : new Date().toLocaleDateString("en-IN");

  const methodLabel = { cash: "Cash", upi: "UPI", online: "Online Transfer" }[payment.payment_method] || payment.payment_method;

  return (
    <Document>
      <Page size="A5" style={styles.page}>

        <View style={styles.headerContainer}>
          <Text style={styles.topTitle}>PAYMENT RECEIPT</Text>
          <Text style={styles.companyName}>A.K. CERAMIC WORLD</Text>
          <Text style={styles.companyAddress}>
            70, Palayamkottai Taluk, V.G Panneer Das Town Bye Pass Road, Reddiyarpatti, TIRUNELVELI - 7
          </Text>
          <Text style={styles.boldText}>GSTIN : 33ACDFA2032P1ZL</Text>
        </View>

        <View style={styles.metaRowContainer}>
          <View style={styles.metaHalfCell}>
            <Text style={styles.boldText}>Receipt No: </Text>
            <Text>{receiptNo}</Text>
          </View>
          <View style={styles.metaHalfCellRight}>
            <Text style={styles.boldText}>Date: </Text>
            <Text>{dateStr}</Text>
          </View>
        </View>

        <View style={styles.receivedBox}>
          <Text style={styles.receivedLine}>
            <Text style={styles.boldText}>Received from: </Text>{customer.name || "—"}
          </Text>
          <Text style={styles.receivedLine}>
            <Text style={styles.boldText}>Phone: </Text>{customer.phone || "—"}
          </Text>
          {customer.address && (
            <Text style={styles.receivedLine}>
              <Text style={styles.boldText}>Address: </Text>{customer.address}
            </Text>
          )}
          <Text style={styles.receivedLine}>
            <Text style={styles.boldText}>Payment mode: </Text>{methodLabel}
            {payment.reference_no ? `  (Ref: ${payment.reference_no})` : ""}
          </Text>
          {payment.notes && (
            <Text style={styles.receivedLine}>
              <Text style={styles.boldText}>Notes: </Text>{payment.notes}
            </Text>
          )}
        </View>

        <View style={styles.amountBox}>
          <Text style={styles.amountLabel}>Amount Received</Text>
          <Text style={styles.amountValue}>₹{Number(payment.amount || 0).toLocaleString("en-IN")}</Text>
        </View>

        <View style={styles.balanceRow}>
          <Text style={styles.boldText}>Balance after this payment</Text>
          <Text style={styles.boldText}>₹{Number(balanceAfter || 0).toLocaleString("en-IN")}</Text>
        </View>

        <View style={styles.signBlock}>
          <View style={styles.signBox}>
            <Text style={styles.boldText}>Authorised Signatory</Text>
          </View>
        </View>

        <Text style={styles.disclaimer}>This is a computer generated receipt.</Text>

      </Page>
    </Document>
  );
}
